import React, { Component } from "react";
import { MQRequest } from "@eres/mortgageQuotationAPI/entities";
import { LocaleUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import ListDataView from "../DataView/ListDataView";
import Strings from "@my-dld/assets/strings";
import {
	getMQAmount,
	getMQArea,
	getMQBank,
	getMQLandNo,
	getMQRefNo,
	getMQReqDate,
	getMQSize,
	getMQTenure,
	getMQUnitNo,
	getMQVillaName
} from "@my-dld/screens/MyDLD/MyRequest/MQRequests";
import { TabuPropertyType } from "@my-dld/utils/PropertyUtils";
import { getOPLabel } from "../Portfolio/PropertyTable";
import { ImperialSystem, UnitSystem } from "@my-dld/utils/UnitUtils";

export interface MQReqProps {
	type: TabuPropertyType;
	items: MQRequest[];
	unit: UnitSystem;
}

class MQRequestsListView extends Component<MQReqProps> {
	componentDidMount(): void {
		this.configDataTable();
	}

	render() {
		const { type, items, unit } = this.props;
		let Header = LandHeader;
		let Row = LandRow;
		switch ( type ) {
			case TabuPropertyType.VILLA:
			case TabuPropertyType.BUILDING:
				Header = VillaHeader;
				Row = VillaRow;
				break;
			case TabuPropertyType.UNIT:
				Header = UnitHeader;
				Row = UnitRow;
				break;
		}
		return <ListDataView
			id={ `mq_${ type }` }
			title={ `${ getOPLabel( type ) } (${ items.length })` }
			items={ items }
			renderListHeader={ () => <Header/> }
			renderListItem={ ( item: MQRequest ) => {
				return <Row
					key={ item.mortgageRequestReference }
					item={ item }
					isSqFt={ unit.Id === ImperialSystem.Id }/>;
			} }/>;
	}

	private configDataTable = () => {
		const { type } = this.props;
		try {
			window.$( `#mq_${ type }` ).DataTable( {
				language: LocaleUtil.Select( DataTableLang ),
				responsive: false,
				lengthChange: false,
				scrollX: true
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};
}

function LandHeader() {
	return <tr>
		<th>{ Strings.land_num_label }</th>
		<Header/>
	</tr>;
}

function VillaHeader() {
	return <tr>
		<th>{ Strings.name }</th>
		<Header/>
	</tr>;
}

function UnitHeader() {
	return <tr>
		<th>{ Strings.Unit_Number_Label }</th>
		<Header/>
	</tr>;
}

function Header() {
	return <>
		<th>{ Strings.area_label }</th>
		<th>{ Strings.size }</th>
		<th>{ Strings.submission_date }</th>
		<th>{ Strings.reference_number }</th>
		<th>{ `${ Strings.amount } (${ Strings.aed })` }</th>
		<th>{ Strings.tenure }</th>
		<th>{ Strings.bank_name }</th>
	</>;
}

export interface MQRowProps {
	item: MQRequest;
	isSqFt: boolean;
}

function LandRow( props: MQRowProps ) {
	const { item } = props;
	return <tr>
		<td data-label={ Strings.land_num_label }>{ getMQLandNo( item ) }</td>
		<Row { ...props } />
	</tr>;
}

function VillaRow( props: MQRowProps ) {
	const { item } = props;
	return <tr>
		<td data-label={ Strings.name }>{ getMQVillaName( item ) }</td>
		<Row { ...props } />
	</tr>;
}

function UnitRow( props: MQRowProps ) {
	const { item } = props;
	return <tr>
		<td data-label={ Strings.Unit_Number_Label }>{ getMQUnitNo( item ) }</td>
		<Row { ...props } />
	</tr>;
}

function Row( props: MQRowProps ) {
	const { item, isSqFt } = props;
	return <>
		<td data-label={ Strings.area_label }>{ getMQArea( item ) }</td>
		<td data-label={ Strings.size }>{ getMQSize( item, isSqFt ) }</td>
		<td data-label={ Strings.submission_date }>{ getMQReqDate( item ) }</td>
		<td data-label={ Strings.reference_number }>{ getMQRefNo( item ) }</td>
		<td data-label={ `${ Strings.amount } (${ Strings.aed })` }>{ getMQAmount( item ) }</td>
		<td data-label={ Strings.tenure }>{ getMQTenure( item ) }</td>
		<td data-label={ Strings.bank_name }>{ getMQBank( item ) }</td>
	</>;
}

export default MQRequestsListView;
